<template>
  <div
    class="card p-3 shadow-sm mb-3 border-0"
    style="border-radius: 12px; border-left: 4px solid #e0f0ec;"
  >
    <div class="card-body p-0">
      <div class="row align-items-center">
        <div class="col-12 col-md-8 d-flex flex-column">
          
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="fw-bold fs-5 text-dark text-truncate">
              {{ fileName }}
            </div>
            <div class="text-muted small text-nowrap">
              N° {{ document.reference }}
            </div>
          </div>

          <div class="d-flex flex-column gap-1 mb-3">
            <div
              v-if="document.type === 'CERTIFICATE_VISA'"
              class="text-muted small"
            >
               <font-awesome-icon icon="file-alt" class="me-1" /> {{ document.documentName }}
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2 mt-auto align-items-center">
            <div
              class="badge badge-pills rounded-pill"
              :class="getDocumentTypeColorClass()"
            >
              {{ getDocumentTypeName() }}
            </div>
            
            <div class="badge badge-pills rounded-pill text-blue-700 bg-yellow-300">
              <template v-if="document.type === 'CERTIFICATE_VISA'">
                Du {{ dateFormat(document.effectiveDate) }} au {{ document.endEffectiveDate ? dateFormat(document.endEffectiveDate) : '...' }}
              </template>
              <template v-else>
                {{ new Date(document.effectiveDate).getFullYear() }}
              </template>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4 mt-3 mt-md-0 d-flex flex-column justify-content-center align-items-md-end gap-2">
          <v-loader
            :next="download"
            title="Télécharger"
            class="btn-download-pill"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { capitalize } from 'lodash-es';

export default {
  props: {
    document: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      colors: [
        { key: 'CERTIFICATE', name: 'Attestation', color: 'yellow-500' },
        {
          key: 'INVOICE', name: 'Facture', color: 'pink-400', textColor: 'white',
        },
        { key: 'PROJECT', name: 'Devis', color: 'yellow-400' },
        { key: 'POLICY', name: 'Contrat', color: 'blue-400' },
        { key: 'AMENDMENT', name: 'Avenant', color: 'blue-300' },
        { key: 'ADVICE', name: 'Conditions générales', color: 'pink-300' },
        { key: 'CERTIFICATE_ACTIVITY', name: 'Attestation Orias', color: 'green-300' },
        { key: '*', name: 'Divers', color: 'green-400' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      products: ['rater/products'],
    }),
    startYear() {
      return (new Date(this.document.effectiveDate)).getFullYear();
    },
    endYear() {
      return (new Date(this.document.endEffectiveDate)).getFullYear();
    },
    documentType() {
      return this.document?.template?.documentType ?? this.document.type;
    },
    documentTypeColor() {
      let obj = this.colors.find(c => c.key === this.documentType);
      if (!obj) obj = this.colors.find(c => c.key === '*');
      return obj;
    },
    fileName() {
      if (this.document.displayName) return this.document.displayName;
      const name = this.document.path.split('/').pop().toString();
      const nameReplaced = name.replace(/\.pdf/g, ' ').split('_').join(' ');
      return capitalize(nameReplaced);
    },
  },
  methods: {
    getDocumentTypeColorClass() {
      const obj = this.documentTypeColor;
      return `bg-${obj.color} text-${obj.textColor || 'blue-700'}`;
    },
    getDocumentTypeName() {
      return this.documentTypeColor.name;
    },
    download() {
      return this.$store.dispatch('download/getDocument', this.document);
    },
    dateFormat(tDate) {
      try {
        const date = new Date(tDate);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        const year = date.getFullYear();

        if (day < 10) day = `0${day}`;
        if (month < 10) month = `0${month}`;
        return [day, month, year].join('/');
      } catch {
        return '';
      }
    },
  },
};
</script>
<style scoped>
@media screen and (max-width:767px) {
  .card {
    min-height:210px;
  }
  .btn-grow {
    width: 100%;
  }
  .btn-download-pill {
    width: 100%;
  }
}
.btn-download-pill {
  border-radius: 50px;
  padding: 12px 36px;
  font-size: 18px;
  font-weight: 600;
  min-width: 180px;
}
</style>
